import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';

import { PageConstant } from 'src/app/constants';
import { LocationType } from 'src/app/models';

@Injectable({
  providedIn: 'root'
})
export class NavigateService {
  constructor(private readonly navController: NavController) {}

  returnToPOSLocationRoot(locationType: LocationType) {
    //Redirect to the correct root page based on Location Type
    let path = PageConstant.DEVICE_REGISTRATION_PAGE;

    if (locationType === LocationType.DiningRoom) {
      path = PageConstant.DINING_FLOORPLAN_PAGE;
    } else if (locationType === LocationType.QuickService) {
      path = PageConstant.QUICK_SERVICE_PAGE;
    } else if (locationType === LocationType.Services) {
      path = PageConstant.SERVICES_BOOKING_PAGE;
    } else if (locationType === LocationType.SelfServe) {
      path = PageConstant.SELF_SERVICE_SETUP_PAGE;
    }

    this.navController.navigateRoot(path);
  }
}
